export default "__VITE_ASSET__5396226a__"